import { render, staticRenderFns } from "./DatenschutzPage.vue?vue&type=template&id=a3d5e53c&scoped=true&"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js&"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzPage.vue?vue&type=style&index=0&id=a3d5e53c&prod&lang=scss&scoped=true&"
import style1 from "./DatenschutzPage.vue?vue&type=style&index=1&id=a3d5e53c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d5e53c",
  null
  
)

export default component.exports